import { gql, useQuery } from '@apollo/client';

const getTierList = gql`
    query GetTierList($featureName: String!) {
        getTierList(featureName: $featureName) {
            tierName
            tierReference
        }
    }
`;
const useTierList = (showTierFilter: boolean) => {
    const { data, loading, error } = useQuery(getTierList, {
        variables: {
            featureName: 'profit_pool',
        },
        skip: !showTierFilter,
    });

    return { data, loading, error };
};

export default useTierList;
